// Plyx → AfriMarket attribution persistence helper.
//
// When a buyer clicks Shop from a Plyx video, we stamp the video_id into
// localStorage with a 24h TTL. Subsequent listing visits (without ?plyx_v in
// the URL) still get attributed — same model Stripe / Amazon use for short
// affiliate sessions. Cleared automatically on expiry or explicit checkout.
const STORAGE_KEY = "plyx_attribution_v1";
const TTL_MS = 24 * 60 * 60 * 1000;

export const recordPlyxAttribution = (videoId) => {
  if (!videoId) return;
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ video_id: videoId, expires_at: Date.now() + TTL_MS }),
    );
  } catch { /* private mode / storage full — silent fail */ }
};

export const getActivePlyxAttribution = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.video_id || !parsed?.expires_at) return null;
    if (Date.now() > parsed.expires_at) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed.video_id;
  } catch {
    return null;
  }
};

export const clearPlyxAttribution = () => {
  try { localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
};
